import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../pages/Dashboard';

import NonDynamicTransportOverview from '../pages/non-dynamic-transport/NonDynamicTransportOverview';
import NonDynamicTransport from '../pages/non-dynamic-transport/NonDynamicTransport';
import NonDynamicTransportCreate from '../pages/non-dynamic-transport/NonDynamicTransportCreate';

import Transportation from '../pages/transportation/Transportation';
import TransportationRoutes from '../pages/transportation/TransportationRoutes';
import TransportationCabins from '../pages/transportation/TransportationCabins';
import TransportationCarTypes from '../pages/transportation/TransportationCarTypes';
import TransportationExtras from '../pages/transportation/TransportationExtras';
import TransportationPrices from '../pages/transportation/TransportationPrices';
import TransportationPersonCategories from '../pages/transportation/TransportationPersonCategories';
import TransportationWrapper from '../pages/transportation/TransportationWrapper';

import Itinerary from '../pages/itinerary/Itinerary';
import ItineraryOverview from '../pages/itinerary/ItineraryOverview';
import ItineraryEditWrapper from '../pages/itinerary/ItineraryEditWrapper';
import ItineraryEditGeneral from '../pages/itinerary/ItineraryEditGeneral';
import ItineraryEditDayProgram from '../pages/itinerary/ItineraryEditDayProgram';
import ItineraryPricesRoutingWrapper from '../pages/itinerary/ItineraryPricesRoutingWrapper';
import ItineraryPrices from '../pages/itinerary/ItineraryPrices';
import ItineraryEditSEO from '../pages/itinerary/ItineraryEditSEO';
import ItineraryEditInclude from '../pages/itinerary/ItineraryEditInclude';
import ItineraryEditIncludeNot from '../pages/itinerary/ItineraryEditIncludeNot';
import ItineraryEditPoster from '../pages/itinerary/ItineraryEditPoster';

import Ski from '../pages/ski/Ski';
import SkistarWrapper from '../pages/ski/skistar/SkistarWrapper';
import SkistarResorts from '../pages/ski/skistar/SkistarResorts';
import SkistarResortAccommodations from '../pages/ski/skistar/SkistarResortAccommodations';
import SkistarResortAddons from '../pages/ski/skistar/SkistarResortAddons';
import SkistarResortWrapper from '../pages/ski/skistar/SkistarResortWrapper';
import SkistarResortUnhandledImages from '../pages/ski/skistar/SkistarResortUnhandledImages';

import RestechWrapper from '../pages/ski/restech/RestechWrapper';
import RestechAddons from '../pages/ski/restech/RestechAddons';

import VisitGroupWrapper from '../pages/ski/visitgroup/VisitGroupWrapper';
import VisitGroupAddons from '../pages/ski/visitgroup/VisitGroupAddons';

import SkiAreas from '../pages/ski/areas/SkiAreas';
import SkiArea from '../pages/ski/areas/SkiArea';
import SkiAreaSnowGuarantee from '../pages/ski/areas/SkiAreaSnowGuarantee';
import SkiAreaFacts from '../pages/ski/areas/SkiAreaFacts';
import SkiAreaSlopeMaps from '../pages/ski/areas/SkiAreaSlopeMaps';
import SkiAreaPickupPlaces from '../pages/ski/areas/SkiAreaPickupPlaces';

import SkiPassWrapper from '../pages/ski/skipass/SkiPassWrapper';
import SkiPassSeason from '../pages/ski/skipass/SkiPassSeason';
import SkiPassSeasons from '../pages/ski/skipass/SkiPassSeasons';
import SkiPassSeasonPriceSettings from '../pages/ski/skipass/SkiPassSeasonPriceSettings';
import SkiPassSeasonPersonCategories from '../pages/ski/skipass/SkiPassSeasonPersonCategories';
import SkiPassSeasonPricePeriods from '../pages/ski/skipass/SkiPassSeasonPricePeriods';
import SkiPassSeasonDiscounts from '../pages/ski/skipass/SkiPassSeasonDiscounts';
import SkiPassSeasonAreas from '../pages/ski/skipass/SkiPassSeasonAreas';
import SkiPassPickupPlaces from '../pages/ski/skipass/SkiPassPickupPlaces';

import SkiSchoolWrapper from '../pages/ski/school/SkiSchoolWrapper';
import SkiSchoolSeason from '../pages/ski/school/SkiSchoolSeason';
import SkiSchoolSeasons from '../pages/ski/school/SkiSchoolSeasons';
import SkiSchoolSeasonPriceSettings from '../pages/ski/school/SkiSchoolSeasonPriceSettings';
import SkiSchoolSeasonPersonCategories from '../pages/ski/school/SkiSchoolSeasonPersonCategories';
import SkiSchoolSeasonPrices from '../pages/ski/school/SkiSchoolSeasonPrices';
import SkiSchoolSeasonLevels from '../pages/ski/school/SkiSchoolSeasonLevels';
import SkiSchoolSeasonAreas from '../pages/ski/school/SkiSchoolSeasonAreas';

import SkiRentalWrapper from '../pages/ski/rental/SkiRentalWrapper';
import SkiRentalSeason from '../pages/ski/rental/SkiRentalSeason';
import SkiRentalSeasons from '../pages/ski/rental/SkiRentalSeasons';
import SkiRentalSeasonPriceSettings from '../pages/ski/rental/SkiRentalSeasonPriceSettings';
import SkiRentalSeasonPersonCategories from '../pages/ski/rental/SkiRentalSeasonPersonCategories';
import SkiRentalSeasonPrices from '../pages/ski/rental/SkiRentalSeasonPrices';
import SkiRentalSeasonDiscounts from '../pages/ski/rental/SkiRentalSeasonDiscounts';
import SkiRentalSeasonAreas from '../pages/ski/rental/SkiRentalSeasonAreas';

import PageNotFound from '../pages/error-pages/PageNotFound';
import { session } from './middleware';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Dashboard,
    },
    {
      path: '/non-dynamic-transportation',
      name: 'NonDynamicTransport',
      component: NonDynamicTransport,
      children: [
        {
          path: 'overview',
          name: 'NonDynamicTransportOverview',
          component: NonDynamicTransportOverview,
        },
        {
          path: 'edit/:id?',
          name: 'NonDynamicTransportCreate',
          component: NonDynamicTransportCreate,
        },
      ],
    },
    {
      path: '/transportation',
      name: 'Transportation',
      component: Transportation,
      children: [
        {
          path: 'overview',
          name: 'overview',
          redirect: { name: 'TransportationRoutes' },
          component: TransportationWrapper,
          children: [
            {
              path: 'routes',
              name: 'TransportationRoutes',
              component: TransportationRoutes,
              meta: {
                title: 'Routes',
              },
            },
            {
              path: 'car-types',
              name: 'TransportationCarTypes',
              component: TransportationCarTypes,
              meta: {
                title: 'Car Types',
              },
            },
            {
              path: 'person-categories',
              name: 'TransportationPersonCategories',
              component: TransportationPersonCategories,
              meta: {
                title: 'Person Categories',
              },
            },
            {
              path: 'cabins',
              name: 'TransportationCabins',
              component: TransportationCabins,
              meta: {
                title: 'Cabins',
              },
            },
            {
              path: 'extras',
              name: 'TransportationExtras',
              component: TransportationExtras,
              meta: {
                title: 'Extras',
              },
            },
            {
              path: 'prices',
              name: 'TransportationPrices',
              component: TransportationPrices,
              meta: {
                title: 'Prices',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/itinerary',
      name: 'Itinerary',
      component: Itinerary,
      children: [
        {
          path: 'overview',
          name: 'ItineraryOverview',
          component: ItineraryOverview,
          meta: {
            title: 'Itinerary Overview',
          },
        },
        {
          path: 'prices/:id',
          name: 'ItineraryPricesRoutingWrapper',
          redirect: { name: 'ItineraryPrices' },
          component: ItineraryPricesRoutingWrapper,
          children: [
            {
              path: ':domainId',
              name: 'ItineraryPrices',
              component: ItineraryPrices,
            },
          ],
        },
        {
          path: 'edit/:id',
          name: 'ItineraryEdit',
          redirect: { name: 'ItineraryEditGeneral' },
          component: ItineraryEditWrapper,
          children: [
            {
              path: 'general',
              name: 'ItineraryEditGeneral',
              component: ItineraryEditGeneral,
              meta: {
                title: 'Edit Itinerary general info',
              },
            },
            {
              path: 'day-program',
              name: 'ItineraryEditDayProgram',
              component: ItineraryEditDayProgram,
              meta: {
                title: 'Edit Itinerary day program',
              },
            },
            {
              path: 'seo',
              name: 'ItineraryEditSEO',
              component: ItineraryEditSEO,
              meta: {
                title: 'Edit Itinerary SEO',
              },
            },
            {
              path: 'include',
              name: 'ItineraryEditInclude',
              component: ItineraryEditInclude,
              meta: {
                title: 'Edit Itinerary Include',
              },
            },
            {
              path: 'include-not',
              name: 'ItineraryEditIncludeNot',
              component: ItineraryEditIncludeNot,
              meta: {
                title: 'Edit Itinerary Include',
              },
            },
            {
              path: 'poster',
              name: 'ItineraryEditPoster',
              component: ItineraryEditPoster,
              meta: {
                title: 'Edit Itinerary Poster',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/ski',
      name: 'Ski',
      component: Ski,
      children: [
        {
          path: 'areas',
          name: 'SkiAreas',
          component: SkiAreas,
        },
        {
          path: 'area/:id',
          name: 'SkiArea',
          component: SkiArea,
          props: true,
          redirect: { name: 'SkiAreaFacts' },
          children: [
            {
              path: 'facts',
              name: 'SkiAreaFacts',
              component: SkiAreaFacts,
            },
            {
              path: 'snow-guarantee',
              name: 'SkiAreaSnowGuarantee',
              component: SkiAreaSnowGuarantee,
            },
            {
              path: 'slope-maps',
              name: 'SkiAreaSlopeMaps',
              component: SkiAreaSlopeMaps,
            },
            {
              path: 'pickup-places',
              name: 'SkiAreaPickupPlaces',
              component: SkiAreaPickupPlaces,
            },
          ],
        },
        {
          path: 'ski-pass',
          name: 'SkiPassWrapper',
          component: SkiPassWrapper,
          redirect: { name: 'SkiPassSeasons' },
          meta: {
            title: 'Ski pass',
          },
          children: [
            {
              path: 'seasons',
              name: 'SkiPassSeasons',
              component: SkiPassSeasons,
              meta: {
                title: 'Ski pass seasons',
              },
            },
            {
              path: 'season/new',
              name: 'NewSkiPassSeason',
              component: SkiPassSeason,
              props: true,
              meta: {
                title: 'New ski pass seasons',
              },
              redirect: { name: 'NewSkiPassSeasonPriceSettings' },
              children: [
                {
                  path: 'price-settings',
                  name: 'NewSkiPassSeasonPriceSettings',
                  component: SkiPassSeasonPriceSettings,
                },
              ],
            },
            {
              path: 'season/:seasonId',
              name: 'SkiPassSeason',
              component: SkiPassSeason,
              props: true,
              meta: {
                title: 'Editing ski pass season',
              },
              redirect: { name: 'SkiPassSeasonPriceSettings' },
              children: [
                {
                  path: 'price-settings',
                  name: 'SkiPassSeasonPriceSettings',
                  component: SkiPassSeasonPriceSettings,
                },
                {
                  path: 'person-categories',
                  name: 'SkiPassSeasonPersonCategories',
                  component: SkiPassSeasonPersonCategories,
                },
                {
                  path: 'price-periods',
                  name: 'SkiPassSeasonPricePeriods',
                  component: SkiPassSeasonPricePeriods,
                },
                {
                  path: 'discounts',
                  name: 'SkiPassSeasonDiscounts',
                  component: SkiPassSeasonDiscounts,
                },
                {
                  path: 'areas',
                  name: 'SkiPassSeasonAreas',
                  component: SkiPassSeasonAreas,
                },
                {
                  path: 'pickup-places',
                  name: 'SkiPassPickupPlaces',
                  component: SkiPassPickupPlaces,
                },
              ],
            },
          ],
        },
        {
          path: 'school',
          name: 'SkiSchoolWrapper',
          component: SkiSchoolWrapper,
          redirect: { name: 'SkiSchoolSeasons' },
          meta: {
            title: 'Ski school',
          },
          children: [
            {
              path: 'seasons',
              name: 'SkiSchoolSeasons',
              component: SkiSchoolSeasons,
              meta: {
                title: 'Ski school seasons',
              },
            },
            {
              path: 'season/new',
              name: 'NewSkiSchoolSeason',
              component: SkiSchoolSeason,
              props: true,
              meta: {
                title: 'New ski school seasons',
              },
              redirect: { name: 'NewSkiSchoolSeasonPriceSettings' },
              children: [
                {
                  path: 'price-settings',
                  name: 'NewSkiSchoolSeasonPriceSettings',
                  component: SkiSchoolSeasonPriceSettings,
                },
              ],
            },
            {
              path: 'season/:seasonId',
              name: 'SkiSchoolSeason',
              component: SkiSchoolSeason,
              props: true,
              meta: {
                title: 'Editing ski school season',
              },
              redirect: { name: 'SkiSchoolSeasonPriceSettings' },
              children: [
                {
                  path: 'price-settings',
                  name: 'SkiSchoolSeasonPriceSettings',
                  component: SkiSchoolSeasonPriceSettings,
                },
                {
                  path: 'person-categories',
                  name: 'SkiSchoolSeasonPersonCategories',
                  component: SkiSchoolSeasonPersonCategories,
                },
                {
                  path: 'prices',
                  name: 'SkiSchoolSeasonPrices',
                  component: SkiSchoolSeasonPrices,
                },
                {
                  path: 'levels',
                  name: 'SkiSchoolSeasonLevels',
                  component: SkiSchoolSeasonLevels,
                },
                {
                  path: 'areas',
                  name: 'SkiSchoolSeasonAreas',
                  component: SkiSchoolSeasonAreas,
                },
                {
                  path: 'pickup-places',
                  name: 'SkiSchoolPickupPlaces',
                  component: SkiPassPickupPlaces,
                  props: {
                    skischool: true,
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'rental',
          name: 'SkiRentalWrapper',
          component: SkiRentalWrapper,
          redirect: { name: 'SkiRentalSeasons' },
          meta: {
            title: 'Ski rental',
          },
          children: [
            {
              path: 'seasons',
              name: 'SkiRentalSeasons',
              component: SkiRentalSeasons,
              meta: {
                title: 'Ski rental seasons',
              },
            },
            {
              path: 'season/new',
              name: 'NewSkiRentalSeason',
              component: SkiRentalSeason,
              props: true,
              meta: {
                title: 'New ski rental seasons',
              },
              redirect: { name: 'NewSkiRentalSeasonPriceSettings' },
              children: [
                {
                  path: 'price-settings',
                  name: 'NewSkiRentalSeasonPriceSettings',
                  component: SkiRentalSeasonPriceSettings,
                },
              ],
            },
            {
              path: 'season/:seasonId',
              name: 'SkiRentalSeason',
              component: SkiRentalSeason,
              props: true,
              meta: {
                title: 'Editing ski rental season',
              },
              redirect: { name: 'SkiRentalSeasonPriceSettings' },
              children: [
                {
                  path: 'price-settings',
                  name: 'SkiRentalSeasonPriceSettings',
                  component: SkiRentalSeasonPriceSettings,
                },
                {
                  path: 'person-categories',
                  name: 'SkiRentalSeasonPersonCategories',
                  component: SkiRentalSeasonPersonCategories,
                },
                {
                  path: 'prices',
                  name: 'SkiRentalSeasonPrices',
                  component: SkiRentalSeasonPrices,
                },
                {
                  path: 'discounts',
                  name: 'SkiRentalSeasonDiscounts',
                  component: SkiRentalSeasonDiscounts,
                },
                {
                  path: 'areas',
                  name: 'SkiRentalSeasonAreas',
                  component: SkiRentalSeasonAreas,
                },
                {
                  path: 'pickup-places',
                  name: 'SkiRentalPickupPlaces',
                  component: SkiPassPickupPlaces,
                  props: {
                    rental: true,
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'skistar',
          name: 'Skistar',
          redirect: { name: 'SkistarResorts' },
          component: SkistarWrapper,
          children: [
            {
              path: 'resorts',
              name: 'SkistarResorts',
              component: SkistarResorts,
              meta: {
                title: 'Skistar Resorts',
              },
            },
            {
              path: 'resorts/:id',
              name: 'SkistarResortWrapper',
              component: SkistarResortWrapper,
              redirect: { name: 'SkistarResortAccommodations' },
              children: [
                {
                  path: 'accommodations',
                  name: 'SkistarResortAccommodations',
                  component: SkistarResortAccommodations,
                  meta: {
                    title: 'Skistar Resort Accommodations',
                  },
                },
                {
                  path: 'addons',
                  name: 'SkistarResortAddons',
                  component: SkistarResortAddons,
                  meta: {
                    title: 'Skistar Resort Addons',
                  },
                },
                {
                  path: 'unhandled-images',
                  name: 'SkistarResortUnhandledImages',
                  component: SkistarResortUnhandledImages,
                  meta: {
                    title: 'Skistar Resort Unhandled Images',
                  },
                },
              ],
            },
          ],
        },
        {
          path: 'restech',
          name: 'Restech',
          redirect: { name: 'RestechAddons' },
          component: RestechWrapper,
          children: [
            {
              path: 'addons',
              name: 'RestechAddons',
              component: RestechAddons,
              meta: {
                title: 'Restech Resorts',
              },
            },
          ],
        },
        {
          path: 'visitgroup',
          name: 'VisitGroup',
          redirect: { name: 'VisitGroupAddons' },
          component: VisitGroupWrapper,
          children: [
            {
              path: 'addons',
              name: 'VisitGroupAddons',
              component: VisitGroupAddons,
              meta: {
                title: 'VisitGroup Addons',
              },
            },
          ],
        },
      ],
    },
    {
      path: '/404',
      name: 'PageNotFound',
      component: PageNotFound,
    },
    {
      path: '*',
      redirect: {
        name: 'PageNotFound',
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  document.title = to.meta && to.meta.title ? to.meta.title : 'Twenty Products';
  if (!to.matched.some(record => record.meta.sessionFree)) {
    return session({ next });
  }
  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js